class MainNavigation {
    constructor(rootElement) {
        if (rootElement) {
            this.rootElement = rootElement
            this.flyout = rootElement.querySelector('.flyout__container')
            this.flyoutItems = this.flyout.querySelectorAll('.flyout__node')
            this.breadcrumbBackLink = this.flyout.querySelectorAll('.flyout__breadcrumb .flyout__link')
            this.flyoutToggleButton = this.rootElement.querySelector('.navigation__button')

            this.registerEventHandlers()
        }
    }

    registerEventHandlers() {
        // open sub menu on item click
        this.flyoutItems.forEach((element) => {
            element.addEventListener('click', (event) => this.showSubMenuOfItem(event.target))
        })
        // open on toggle button click
        this.flyoutToggleButton.addEventListener('click', (event) => this.toggleFlyout())
        // hide menu on modal open
        document.addEventListener('show.bs.modal', () => this.hideFlyout())
        // hide menu on ESC key press
        document.addEventListener('keydown', (event) => {
            if(event.key.toLowerCase() === 'escape' && this.isFlyoutActive()) {
                this.hideFlyout()
            }
        })
        // hide on "click outside"
        document.addEventListener('click', (event) => {
            const withinBoundaries = event.composedPath().includes(this.rootElement)
            if (!withinBoundaries && this.isFlyoutActive()) this.hideFlyout()
        })
        // hide current flyout via back button
        this.breadcrumbBackLink.forEach((element) => {
            element.addEventListener('click', () => {
                this.hideFlyout(element.closest('.flyout__item.is-active'))
            })
        })
    }

    isFlyoutActive(element = null) {
        return (element ?? this.flyout).classList.contains('is-active')
    }

    isFirstLevel(element) {
        return element.parentNode.classList.contains('flyout__list--primary')
    }

    showSubMenuOfItem(item) {
        this.toggleFlyout(item.parentNode)
    }

    hideAllFlyouts(parent) {
        parent.querySelectorAll('.is-active').forEach((element) => {
            this.hideFlyout(element)
        })
    }

    showFlyout(element = null) {
        element = element ?? this.flyout
        this.hideAllFlyouts(element.parentNode)
        element.classList.add('is-active')

        let subFlyout = element.querySelector('.flyout__list')

        if (subFlyout) {
            subFlyout.classList.add('is-activated')
        }

        if (element === this.flyout) {
            this.toggleButtonCollapse()
        }
    }

    toggleButtonCollapse() {
        this.flyoutToggleButton.classList.toggle('collapsed')
    }

    hideFlyout(element = null) {
        element = element ?? this.flyout
        element.classList.remove('is-active')
        this.hideAllFlyouts(element.parentNode)

        let subFlyout = element.querySelector('.flyout__list')

        if (subFlyout) {
            subFlyout.classList.remove('is-activated')
        }

        if (element === this.flyout) {
            this.toggleButtonCollapse()
        }
    }

    toggleFlyout(element = null) {
        element = (element ?? this.flyout)

        if (this.isFlyoutActive(element)) {
            this.hideFlyout(element)
        } else {
            this.showFlyout(element)
        }
    }
}
document.addEventListener('DOMContentLoaded', () => new MainNavigation(document.querySelector('.header__navigation')));
